import { render } from "./CounterOfferForm.vue?vue&type=template&id=08550ef7&scoped=true&ts=true&lang=pug"
import script from "./CounterOfferForm.vue?vue&type=script&lang=ts"
export * from "./CounterOfferForm.vue?vue&type=script&lang=ts"

import "./CounterOfferForm.vue?vue&type=style&index=0&id=08550ef7&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08550ef7"]])

export default __exports__